import React, { useState } from "react";
import "./testmonial.scss";
import { FaStar } from "react-icons/fa";
import { CiStar } from "react-icons/ci";
import { RiDoubleQuotesL } from "react-icons/ri";

import Testimonial1 from "../../../imgs/details/details1.png";

const Testmonial = () => {
  const [itemData, setItemData] = useState(1);
  const testimonialData = [
    {
      id: 1,
      name: "Pragaj Patel",
      review:
        "Good institute for learning a language. Clear explanations, regular speaking practice, and a friendly environment.",
      media: Testimonial1,
      rating: 4,
    },
    {
      id: 2,
      name: "Samarth Girase",
      review:
        "I started learning here a few months ago and my speaking has improved a lot. The classes are interactive and the teacher is supportive. Good place if you want regular practice.",
      media: Testimonial1,
      rating: 4,
    },
    {
      id: 3,
      name: "Pranav Patel",
      review:
        "A nice balance of language training and consultancy support. The trainers are patient and approachable, and the guidance feels practical and honest.",
      media: Testimonial1,
      rating: 4,
    },
    {
      id: 4,
      name: "Jeel tailor",
      review:
        "I’m happy I chose this institute. The language classes improved my confidence and the consultancy support made the whole process much easier.",
      media: Testimonial1,
      rating: 4,
    },
    {
      id: 5,
      name: "Kajal Darbar",
      review:
        "Simple teaching style, supportive staff, and clear consultancy guidance. I would recommend this institute to other students.",
      media: Testimonial1,
      rating: 4,
    },
  ];

  console.log(itemData);
  return (
    <div className="detailTestmonial">
      <div className="dtHeading">Hear from our Brilliant Students</div>
      <div className="dtBottom">
        <div className="dtbLeft">
          <div className="dtRating">
            <h3>4.8</h3>
            <span>325 reviews</span>
          </div>
          <div className="dtStars">
            <div className="dtStar">
              <span className="allStars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                (90%)
              </span>
              <div className="dtLine">
                <div className="dtLineFill" />
              </div>
            </div>
            <div className="dtStar">
              <span className="allStars">
                <FaStar />
                <FaStar />
                <FaStar />
                <CiStar />
                (5%)
              </span>
              <div className="dtLine">
                <div
                  className="dtLineFill"
                  style={{
                    width: "40%",
                  }}
                />
              </div>
            </div>
            <div className="dtStar">
              <span className="allStars">
                <FaStar />
                <FaStar />
                <CiStar />
                <CiStar />
                (3%)
              </span>
              <div className="dtLine">
                <div
                  className="dtLineFill"
                  style={{
                    width: "25%",
                  }}
                />
              </div>
            </div>
            <div className="dtStar">
              <span className="allStars">
                <FaStar />
                <CiStar />
                <CiStar />
                <CiStar />
                (2%)
              </span>
              <div className="dtLine">
                <div
                  className="dtLineFill"
                  style={{
                    width: "10%",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="dtbRight">
          <div
            className="dtItems"
            style={{
              transform: `translateX(${itemData * -110}%)`,
            }}
          >
            {testimonialData.map((item) => {
              return (
                <div key={item.id} className="dtItem">
                  <RiDoubleQuotesL className="upperQuote" />
                  <RiDoubleQuotesL className="bottomQuote" />

                  <p>{item.review}</p>
                  <div className="dtReview">
                    <img src={item.media} alt="" />
                    <div className="dtName">
                      <span>{item.name}</span>
                      <br />
                      <span className="reviewstar">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="dtDots">
            {testimonialData.map((item) => (
              <div
                key={item.id}
                className="dtDot"
                onClick={() => setItemData(item.id)}
                style={{
                  backgroundColor: item.id === itemData && "#2D3080",
                }}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testmonial;
